// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".titleText___SEGhd{font-size:22px}.outputText___ErdrK{font-weight:400;font-size:14px}.nameField___mOOpb{width:512px}.descriptionField___c347l{width:1056px}\n", "",{"version":3,"sources":["webpack://./src/components/CreateExpressionForm/CreateExpressionForm.css"],"names":[],"mappings":"AAAA,mBACI,cAAA,CAGJ,oBACI,eAAA,CACA,cAAA,CAGJ,mBACI,WAAA,CAGJ,0BACI,YAAA","sourcesContent":[".titleText {\n    font-size: 22px;\n}\n\n.outputText {\n    font-weight: 400;\n    font-size: 14px;\n}\n\n.nameField {\n    width: 512px;\n}\n\n.descriptionField {\n    width: 1056px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": "titleText___SEGhd",
	"outputText": "outputText___ErdrK",
	"nameField": "nameField___mOOpb",
	"descriptionField": "descriptionField___c347l"
};
export default ___CSS_LOADER_EXPORT___;
